import { IconProps } from 'assets'
import React from 'react'

const IntegralOpenLogo = ({ className }: IconProps): JSX.Element => {
  return (
    <svg
      className={className}
      width="220"
      height="48"
      viewBox="0 0 220 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_59_231)">
        <path
          d="M17.4016 20.545C15.5354 22.411 15.5354 25.4365 17.4016 27.3025L36.5479 46.448C38.414 48.314 41.4396 48.314 43.3057 46.448L62.452 27.3025C64.3182 25.4365 64.3182 22.411 62.452 20.545L52.3811 10.4745L49.026 13.8295L57.5767 22.3798C58.4291 23.2322 58.4291 24.6143 57.5767 25.4667L41.6907 41.352C40.8382 42.2044 39.4561 42.2044 38.6036 41.352L22.7177 25.4667C21.8652 24.6143 21.8652 23.2322 22.7177 22.3798L38.6036 6.49459C39.4561 5.64215 40.8382 5.64215 41.6907 6.49459L42.6649 7.4687L46.02 4.11372L43.3057 1.39953C41.4396 -0.466511 38.414 -0.466512 36.5479 1.39953L17.4016 20.545Z"
          fill="url(#paint0_linear_59_231)"
        />
        <path
          d="M47.4359 12.2395L50.791 8.88451L47.6101 5.70373L44.255 9.05872L47.4359 12.2395Z"
          fill="url(#paint1_linear_59_231)"
        />
        <path
          d="M32.7666 20.546C30.9005 22.4121 30.9005 25.4375 32.7666 27.3036L42.8373 37.3738L46.1918 34.0194L37.6403 25.4683C36.7878 24.6158 36.7878 23.2337 37.6403 22.3813L53.5262 6.4961C54.3787 5.64366 55.7608 5.64366 56.6133 6.4961L72.4993 22.3813C73.3517 23.2337 73.3517 24.6158 72.4993 25.4683L56.6133 41.3535C55.7608 42.2059 54.3787 42.2059 53.5262 41.3535L52.5529 40.3802L49.1984 43.7346L51.9129 46.449C53.7791 48.3151 56.8047 48.3151 58.6708 46.449L77.8171 27.3036C79.6832 25.4375 79.6832 22.4121 77.8171 20.546L58.6708 1.40056C56.8047 -0.465481 53.7791 -0.465481 51.9129 1.40056L32.7666 20.546Z"
          fill="url(#paint2_linear_59_231)"
        />
        <path
          d="M47.6083 42.1446L50.9628 38.7902L47.7819 35.6094L44.4274 38.9638L47.6083 42.1446Z"
          fill="url(#paint3_linear_59_231)"
        />
      </g>
      <path
        d="M93.9762 32.4243V15.4833H97.0104V32.4243H93.9762ZM107.416 19.5036C109.001 19.5036 110.256 20.0177 111.184 21.046C112.111 22.0574 112.574 23.4397 112.574 25.1928V32.4243H109.666V25.6479C109.666 24.6533 109.388 23.8611 108.832 23.2711C108.293 22.6642 107.576 22.3608 106.683 22.3608C105.705 22.3608 104.896 22.7064 104.255 23.3975C103.615 24.0718 103.295 24.9483 103.295 26.0272V32.4243H100.387V19.8576H103.244V21.4758H103.345C104.323 20.161 105.68 19.5036 107.416 19.5036ZM124.581 19.8576V22.6895H119.145V28.5051C119.145 29.23 119.524 29.5924 120.283 29.5924H124.581V32.4243H119.701C118.606 32.4243 117.754 32.1293 117.147 31.5393C116.541 30.9325 116.237 30.0897 116.237 29.0108V22.6895H114.214V19.8576H116.237V15.4833H119.145V19.8576H124.581ZM132.425 19.5036C134.498 19.5036 136.133 20.2369 137.33 21.7034C138.527 23.1531 139.032 24.9652 138.847 27.1397H128.91C129.028 27.9657 129.407 28.6653 130.048 29.2384C130.705 29.7947 131.514 30.0812 132.475 30.0981C133.183 30.1149 133.824 29.9801 134.397 29.6935C134.97 29.3901 135.383 28.9855 135.636 28.4798H138.645C138.24 29.8284 137.473 30.8819 136.344 31.6405C135.231 32.399 133.925 32.7783 132.425 32.7783C130.436 32.7783 128.851 32.1378 127.671 30.8566C126.491 29.5755 125.901 28.0078 125.901 26.1536C125.901 24.2656 126.508 22.6895 127.722 21.4253C128.952 20.1442 130.52 19.5036 132.425 19.5036ZM132.374 22.1838C131.514 22.1838 130.773 22.4198 130.149 22.8918C129.542 23.3638 129.146 23.9875 128.961 24.7629H135.838C135.653 23.9706 135.248 23.3469 134.624 22.8918C134.001 22.4198 133.251 22.1838 132.374 22.1838ZM151.089 21.6023V19.8576H153.971V33.6633C153.971 34.8938 153.634 35.8378 152.96 36.4952C152.286 37.1526 151.333 37.4813 150.103 37.4813H142.113V34.5988H149.572C150.044 34.5988 150.406 34.4724 150.659 34.2196C150.929 33.9667 151.064 33.6127 151.064 33.1576L151.089 31.2612V30.6038H150.962C150.002 32.0535 148.577 32.7783 146.689 32.7783C144.902 32.812 143.419 32.2052 142.239 30.9578C141.076 29.7104 140.494 28.109 140.494 26.1536C140.494 24.1982 141.076 22.5968 142.239 21.3494C143.402 20.102 144.886 19.4867 146.689 19.5036C147.633 19.5205 148.468 19.7227 149.192 20.1104C149.934 20.4813 150.524 20.9786 150.962 21.6023H151.089ZM147.271 29.9969C148.383 29.9969 149.294 29.6261 150.002 28.8844C150.71 28.1258 151.064 27.2071 151.064 26.1283C151.064 25.0326 150.71 24.1139 150.002 23.3722C149.294 22.6305 148.383 22.2597 147.271 22.2597C146.141 22.2597 145.214 22.6305 144.489 23.3722C143.781 24.1139 143.427 25.0326 143.427 26.1283C143.427 27.224 143.781 28.1427 144.489 28.8844C145.214 29.6261 146.141 29.9969 147.271 29.9969ZM163.401 19.8576H165.955V22.7907H163.351C162.356 22.7907 161.547 23.1025 160.924 23.7262C160.317 24.3499 160.013 25.2012 160.013 26.28V32.4243H157.105V19.8576H159.912V21.931H160.013C160.603 20.5487 161.733 19.8576 163.401 19.8576ZM177.362 21.6023V19.8576H180.244V32.4243H177.362V30.6038H177.235C176.274 32.0535 174.85 32.7783 172.962 32.7783C171.175 32.812 169.692 32.2052 168.512 30.9578C167.349 29.7104 166.767 28.109 166.767 26.1536C166.767 24.1982 167.349 22.5968 168.512 21.3494C169.675 20.102 171.158 19.4867 172.962 19.5036C173.906 19.5205 174.74 19.7227 175.465 20.1104C176.207 20.4813 176.797 20.9786 177.235 21.6023H177.362ZM173.544 29.9969C174.656 29.9969 175.566 29.6261 176.274 28.8844C176.982 28.1258 177.336 27.2071 177.336 26.1283C177.336 25.0326 176.982 24.1139 176.274 23.3722C175.566 22.6305 174.656 22.2597 173.544 22.2597C172.414 22.2597 171.487 22.6305 170.762 23.3722C170.054 24.1139 169.7 25.0326 169.7 26.1283C169.7 27.224 170.054 28.1427 170.762 28.8844C171.487 29.6261 172.414 29.9969 173.544 29.9969ZM183.252 28.9855V14.219H186.16V28.5051C186.16 29.2468 186.539 29.6177 187.298 29.6177H189.143V32.4243H186.792C185.662 32.4243 184.786 32.1293 184.162 31.5393C183.555 30.9325 183.252 30.0812 183.252 28.9855Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i_59_231"
          x="16.002"
          y="0"
          width="63.2147"
          height="49.8485"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_59_231" />
        </filter>
        <linearGradient
          id="paint0_linear_59_231"
          x1="55.2918"
          y1="0.000987678"
          x2="55.2918"
          y2="47.8485"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#BBE6FF" />
          <stop offset="1" stopColor="#00C3C3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_59_231"
          x1="55.2918"
          y1="0.000987678"
          x2="55.2918"
          y2="47.8485"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#BBE6FF" />
          <stop offset="1" stopColor="#00C3C3" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_59_231"
          x1="55.2918"
          y1="0.000987678"
          x2="55.2918"
          y2="47.8485"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#BBE6FF" />
          <stop offset="1" stopColor="#00C3C3" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_59_231"
          x1="55.2918"
          y1="0.000987678"
          x2="55.2918"
          y2="47.8485"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#BBE6FF" />
          <stop offset="1" stopColor="#00C3C3" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default IntegralOpenLogo
